import { Location } from '../components/user-access/UserAccessLocationPicker';
import { AccessControlChannel } from '../types/AccessControl';
import { AccessLocation } from '../hooks/types/AccessLocation';
import { formatAccessUserRoles } from './formatAccessManagerRole';


export const buildLocationData = (
  channels: AccessControlChannel[],
  currentChannelId: string
): Location[] => {
  channels.sort(
    (a, b) =>
      compareByPropertyChannelId(a, b) || compareAlphabetically(a.name, b.name)
  );
  const locationMap: { [key: string]: Location } = {};

  channels.forEach(channel => {
    const { channelId, name, profile, userRoles, type, isConnectedByTemplate } =
      channel;
    const isCurrentChannel = channel.channelId === currentChannelId;
    const location: Location = {
      id: channelId,
      name,
      isCurrentChannel,
      logo: profile.logo,
      image: profile.image,
      userRoles: userRoles ?? [],
      type,
      isConnectedByTemplate,
    };

    if (channel.propertyChannelId && locationMap[channel.propertyChannelId]) {
      const parentLocation = locationMap[channel.propertyChannelId];

      parentLocation.childLocations = (
        parentLocation.childLocations || []
      ).concat(location);
    } else {
      locationMap[channel.channelId] = location;
    }
  });

  return Object.values(locationMap).sort((a, b) =>
    compareAlphabetically(a.name, b.name)
  );
};

const compareByPropertyChannelId = (
  a: AccessControlChannel,
  b: AccessControlChannel
) => {
  if (!a.propertyChannelId && b.propertyChannelId) return -1;

  if (a.propertyChannelId && !b.propertyChannelId) return 1;

  return 0;
};

const compareAlphabetically = (a: string, b: string) => {
  return a.localeCompare(b);
};


/**
 * Flattens AccessLocation[] and their tenants into a flat array of AccessControlChannel.
 * Each tenant is mapped to an AccessControlChannel with propertyChannelId set to its parent channelId.
 */
export const flattenAccessLocationsToChannels = (
  locations: AccessLocation[],
): AccessControlChannel[] => {
  const result: AccessControlChannel[] = [];

  locations.forEach(location => {

     // Parent location
    const parentChannel: AccessControlChannel = {
      channelId: location.channelId,
      name: location.name,
      propertyChannelId: location.parentId || null,
      type: location.type || null,
      profile: {
        image: location.image || '',
        logo: location.logo || '',
      },
      isConnectedByTemplate: false,
      userRoles: formatAccessUserRoles(location.userRoles || []),
      
    };

    result.push(parentChannel);

    // Tenants as child locations (flattened)
    if (location.tenants && location.tenants.length > 0) {
      location.tenants.forEach(tenant => {
        result.push({
          channelId: tenant.channelId,
          name: tenant.name || '',
          propertyChannelId: location.channelId, // Set parent
          type: tenant.type || null,
          profile: {
            image: tenant.image || '',
            logo: tenant.logo || '',
          },
          isConnectedByTemplate: false,
          userRoles: formatAccessUserRoles(tenant.userRoles || []),
          
        });
      });
    }
  });

  return result;
};
